/* SVT hero slideshow — native scroll-snap track with optional autoplay.
   Swipe and keyboard come from the scroller itself; this only advances it and
   keeps the bars in step. Autoplay stops for good once a visitor takes over. */
class SvtHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.svt-hero__track');
    this.bars = Array.from(this.querySelectorAll('.svt-hero__bar'));
    this.slides = Array.from(this.querySelectorAll('.svt-hero__slide'));
    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.userTook = false;

    this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((evt) =>
      this.track.addEventListener(evt, () => this.stop(), { passive: true })
    );

    if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.start();
      document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.start()));
    }
  }

  disconnectedCallback() {
    this.pause();
  }

  onScroll() {
    clearTimeout(this._t);
    this._t = setTimeout(() => {
      const w = this.track.clientWidth || 1;
      this.setIndex(Math.round(this.track.scrollLeft / w));
    }, 90);
  }

  setIndex(i) {
    this.index = Math.max(0, Math.min(i, this.slides.length - 1));
    this.bars.forEach((b, n) => b.classList.toggle('is-selected', n === this.index));
  }

  start() {
    if (this.userTook || this._timer) return;
    const ms = parseInt(this.dataset.speed, 10) || 5000;
    this._timer = setInterval(() => {
      const next = (this.index + 1) % this.slides.length;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
      this.setIndex(next);
    }, ms);
  }

  pause() {
    clearInterval(this._timer);
    this._timer = null;
  }

  stop() {
    this.userTook = true;
    this.pause();
  }
}

if (!customElements.get('svt-hero-slideshow')) {
  customElements.define('svt-hero-slideshow', SvtHeroSlideshow);
}
